// extracted by mini-css-extract-plugin
export default {"container":"Viewers_container__pRvQb","wrapper":"Viewers_wrapper__QpoeO"};